<script>
import { mapState } from 'vuex'
import RoomTypeList from '@components/room-type-list'
import RoomTypeDetail from '@components/room-type-detail'

export default {
  metaInfo: {
    title: 'Room Type',
    meta: [{ name: 'description', content: 'Room Type' }],
  },

  components: { RoomTypeList, RoomTypeDetail },

  data() {
    return {
      item: {},
      currentView: 'RoomTypeList',
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
    currentProps() {
      const props = { propertyId: this.currentProperty.id }

      if (this.currentView === 'RoomTypeDetail') {
        props.item = this.item
      }

      return props
    },
  },

  methods: {
    onEvent(data) {
      this.currentView = data.currentView
      this.item = data.item ? data.item : {}
    },
  },
}
</script>

<template>
  <component :is="currentView" v-bind="currentProps" @event="onEvent" />
</template>
